var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 10H15.3333V7.33335H12.6666M14 24.6667C8.11996 24.6667 3.33329 19.88 3.33329 14C3.33329 8.12002 8.11996 3.33335 14 3.33335C19.88 3.33335 24.6666 8.12002 24.6666 14C24.6666 19.88 19.88 24.6667 14 24.6667ZM14 0.666687C12.249 0.666687 10.5152 1.01156 8.89751 1.68163C7.27984 2.35169 5.80998 3.33382 4.57187 4.57193C2.07138 7.07241 0.666626 10.4638 0.666626 14C0.666626 17.5362 2.07138 20.9276 4.57187 23.4281C5.80998 24.6662 7.27984 25.6484 8.89751 26.3184C10.5152 26.9885 12.249 27.3334 14 27.3334C17.5362 27.3334 20.9276 25.9286 23.428 23.4281C25.9285 20.9276 27.3333 17.5362 27.3333 14C27.3333 12.2491 26.9884 10.5152 26.3184 8.89757C25.6483 7.2799 24.6662 5.81004 23.428 4.57193C22.1899 3.33382 20.7201 2.35169 19.1024 1.68163C17.4847 1.01156 15.7509 0.666687 14 0.666687ZM12.6666 20.6667H15.3333V12.6667H12.6666V20.6667Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltipIcon);
export default __webpack_public_path__ + "static/media/infoTooltipIcon.d7d2ed4e6c6c2cfe071284b8df2c0fbd.svg";
export { ForwardRef as ReactComponent };